export enum AUTHENTICATION_OPTION {
  EMAIL_PASSWORD = "email_password",
  SSO = "sso",
}

export type AuthResponse = {
  authentication_options: AUTHENTICATION_OPTION[];
  organization_uuid?: string;
};
